import React from 'react';
import { Link } from 'react-router-dom';
import { BrushDivider } from './Motifs';

const LOGO_WHITE = '/images/logo-white.png';

const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-aizome text-ivory overflow-hidden"
        >
            {/* Kanji watermark */}
            <div
                aria-hidden="true"
                style={{ color: 'rgba(255, 255, 255, 0.05)' }}
                className="absolute -top-10 -left-6 right-0 pointer-events-none select-none font-jp text-[200px] md:text-[320px] leading-none whitespace-nowrap font-light"
            >
                中山道
            </div>

            <div className="relative px-6 md:px-12 lg:px-24 py-20 md:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                    {/* Big invitation */}
                    <div className="lg:col-span-7">
                        <p className="overline text-ivory/60">Let's Talk</p>
                        <h2 className="mt-6 font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.0] tracking-tight">
                            Begin your<br />
                            <em className="italic">value journey.</em>
                        </h2>
                        <BrushDivider className="w-40 h-3 mt-8" color="rgba(255, 255, 255, 0.5)" />
                        <a
                            href="mailto:m@nakasendocapital.com"
                            data-testid="footer-cta-email"
                            className="btn-light mt-10"
                        >
                            m@nakasendocapital.com <span className="arrow">→</span>
                        </a>
                    </div>

                    {/* Links + meta */}
                    <div className="lg:col-span-5 grid grid-cols-2 gap-10">
                        <div>
                            <p className="overline text-ivory/50 mb-5">Navigate</p>
                            <ul className="space-y-3">
                                {[
                                    { to: '/', label: 'Home' },
                                    { to: '/about', label: 'About' },
                                    { to: '/services', label: 'Services' },
                                    { to: '/contact', label: 'Contact' },
                                ].map((it) => (
                                    <li key={it.to}>
                                        <Link
                                            to={it.to}
                                            data-testid={`footer-link-${it.label.toLowerCase()}`}
                                            className="font-serif text-xl text-ivory/85 hover:text-ivory transition-colors duration-300 link-underline"
                                        >
                                            {it.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <p className="overline text-ivory/50 mb-5">Connect</p>
                            <ul className="space-y-3">
                                <li>
                                    <a
                                        href="mailto:m@nakasendocapital.com"
                                        data-testid="footer-link-email"
                                        className="font-serif text-xl text-ivory/85 hover:text-ivory transition-colors duration-300 link-underline"
                                    >
                                        Email
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://sg.linkedin.com/in/marinasurzhenko"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid="footer-link-linkedin"
                                        className="font-serif text-xl text-ivory/85 hover:text-ivory transition-colors duration-300 link-underline"
                                    >
                                        LinkedIn
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-ivory/10 flex flex-col md:flex-row justify-between gap-6 md:items-center">
                    <Link to="/" className="flex items-center gap-3" data-testid="footer-logo">
                        <img
                            src={LOGO_WHITE}
                            alt="Nakasendo Capital"
                            className="h-10 w-auto"
                            loading="lazy"
                        />
                    </Link>
                    <div className="flex items-center gap-8 text-[12px] tracking-[0.18em] uppercase text-ivory/45">
                        <span>© {year} Nakasendo Capital</span>
                        <span>Singapore · Asia</span>
                        <span className="font-jp tracking-normal text-ivory/60">中山道</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
